import React from "react";
import 'chart.js/auto';
import { Chart } from 'react-chartjs-2';

export default function BarChartTotal() {
  const labels = ["ม.ค.", "ก.พ.", "มี.ค." , "เม.ย." , "พ.ค." , "มิ.ย." , "ก.ค.", "ส.ค.", "ก.ย.", "ต.ค.","พ.ย.","ธ.ค." ];

  const dataNew = {
    labels,
    datasets: [
      {
        type: "line",
        label: "อุณหภูมิ",
        borderColor: "#AEFC44",
        barPercentage: 0.3,
        data: [36, 35, 36.5, 37, 37.2, 36, 36.8, 36.4, 36.2, 36.8, 37.3, 36],
        borderDash: [10, 5],
      },
      {
        type: "bar",
        label: "จำนวนคนอุณหภูมิปกติ",
        backgroundColor: "rgba(186, 178, 244, 1)",
        data: [10, 20, 30, 40, 50, 50, 30, 10, 15, 12, 11, 30],
        borderColor: "white",
        barPercentage: 0.3,
        borderSkipped: false,
        borderRadius: Number.MAX_VALUE,
      },
      {
        type: "bar",
        label: "จำนวนคนอุณหภูมิสูง",
        backgroundColor: "rgba(255, 132, 132, 0.5)",
        data: [2, 3, 9, 1, 2, 3, 5, 7, 9, 4, 3, 8],
        barPercentage: 0.3,
        borderSkipped: false,
        borderRadius: Number.MAX_VALUE,
      },
    ],
  };

  const data = {
    labels,
    datasets: [
      {
        label: "จำนวนคนอุณหภูมิปกติ",
        data: [10, 20, 30, 40, 50, 50, 30, 10, 15, 12, 11, 30],
        backgroundColor: "rgba(186, 178, 244, 1)",
        borderRadius: {
          topLeft: Number.MAX_VALUE,
          topRight: Number.MAX_VALUE,
          bottomLeft: Number.MAX_VALUE,
          bottomRight: Number.MAX_VALUE,
        },
        barPercentage: 0.3,
        borderSkipped: "false",
      },
      {
        label: "จำนวนคนอุณหภูมิสูง",
        data: [2, 3, 9, 1, 2, 3, 5, 7, 9, 4, 3, 8],
        backgroundColor: "rgba(255, 132, 132, 0.5)",
        borderRadius: Number.MAX_VALUE,
        barPercentage: 0.3,
        borderSkipped: "false",
      },
    ],
  };

  const options = {
    responsive: true,
    // maintainAspectRatio: false,
    // plugins: {
    //   legend: {
    //     position: "top",
    //     align: "end",
    //   },
    //   title: {
    //     display: false,
    //     text: "Chart.js Bar Chart",
    //     align: "center",
    //   },
    // },
    scales: {
      x: {
        grid: {
          display: false
        }
      },
      y: {
        grid: {
          display: false
        }
      }
    }
    // scales: {
    //   xAxes: [
    //     {
    //       gridLines: {
    //         display: false,
    //       },
    //     },
    //   ],
    //   yAxes: [
    //     {
          // ticks: {
          //   beginAtZero: true,
          // },
    //       gridLines: {
    //         display: false,
    //       },
    //     },
    //   ],
    // },
  };

  return (
    <Chart style={{ height: "400px", maxHeight:'400px' }} options={options} data={dataNew} />
  );
}
